module.exports = __webpack_public_path__ + "static/media/dnata.c0f2651b.png";